import { Backdrop, CircularProgress } from '@mui/material'
import { FC } from 'react'

// общий лоадер для сайта (затемняет и крутиться в центре)
export const Loading: FC = () => {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
      open={true}
      // onClick={handleClose}
    >
      <CircularProgress color='inherit' />
    </Backdrop>
  )
}
